import Cookie from 'cookie-universal'
import queryString from 'query-string'
import { experiment } from './contexts'
import { logger } from '@cred/fe-logger'

let expiration = new Date()

expiration.setMilliseconds(expiration.getMilliseconds() + 365 * 864e5)

const cookieOptions = { path: '/' },
  browserCookies = () => Cookie().getAll(cookieOptions),
  extractChildrenText = (children) => {
    if (typeof children === 'string') {
      return children
    } else if (Array.isArray(children)) {
      return children.join(' ')
    }

    return ''
  },
  activateWidgetsExperimentContext = (experiments) => {
    const { activeExperiments, experiments: experimentConfig, variationMap } = experiments

    activeExperiments.forEach((experimentId) => {
      const foundExperiment = experimentConfig.find((experiment) => experiment.id === experimentId),
        { name: experimentName, variations } = foundExperiment,
        foundVariation = variations.find((variation) => variation.id == variationMap[experimentId]),
        { description: variationName, id: variationId } = foundVariation

      window.snowplow('addGlobalContexts', [
        experiment.analytics({
          experimentId,
          experimentName,
          variationId: `${variationId}`,
          variationName
        })
      ])
    })
  },
  cleanUtmParameters = ({ pathname, routeName, query, replace }) => {
    if (!global.window || !query || !replace || !pathname) {
      return
    }

    const utms = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_internal',
      'utm_referrer',
      'user_agent',
      'gclid',
      'kclickid',
      'msclkid',
      'gbraid',
      'wbraid',
      'loanAmount',
      'loanPurpose',
      'vsp',
      'preferred_lender',
      'email_proxy_id',
    ]

    const queryParamKeys = Object.keys(query)
    const needToClearUrl = queryParamKeys.some((p) => utms.includes(p))

    if (!needToClearUrl) return

    const newParams = queryParamKeys.reduce((acc, p) => {
      const item = !utms.includes(p) ? { [p]: query[p] } : {}

      return { ...acc, ...item }
    }, {})

    const stringifyNewParams = !!Object.keys(newParams).length
      ? `?${queryString.stringify(newParams)}`
      : ''
    const path = routeName ? routeName : `${pathname}${stringifyNewParams}`

    replace(path, `${pathname}${stringifyNewParams}`)
  }

const utmValidator = (utm, utmValue, maxLength) => {
  if (!utmValue) return undefined
  if (utmValue.length > maxLength) {
    logger.error(
      'Add Attribution global context error',
      {
        error: `${utm} utm does not conform to schema field's length restriction (${maxLength})`,
        utm,
        utmValue,
      },
      'Attribution context failed'
    )
    return `${utmValue.substring(0, maxLength - 3)}...`
  }

  return utmValue
}

export { activateWidgetsExperimentContext, extractChildrenText, cleanUtmParameters, browserCookies, utmValidator }
